import { useEffect, useMemo } from "react";
import { useGetUserProfileQuery } from "../../features/users/usersApi";
import {
  identifyLiveChatCustomer,
  initLiveChatSidebarMode,
} from "../../utils/liveChatWidget";

const LiveChatSidebarIntegration = () => {
  const hasToken =
    typeof window !== "undefined" && Boolean(localStorage.getItem("accessToken"));

  const { data: profileResponse } = useGetUserProfileQuery(undefined, {
    skip: !hasToken,
  });

  const customer = useMemo(() => {
    const user = profileResponse?.data;
    if (!user) return null;
    const name =
      user.full_name?.trim() ||
      `${user.first_name || ""} ${user.last_name || ""}`.trim();
    return {
      name: name || undefined,
      email: user.email?.trim() || undefined,
    };
  }, [profileResponse?.data]);

  useEffect(() => {
    initLiveChatSidebarMode();
  }, []);

  useEffect(() => {
    if (!customer?.email && !customer?.name) return;
    identifyLiveChatCustomer(customer);
  }, [customer]);

  return null;
};

export default LiveChatSidebarIntegration;
